import { render } from "./Singleocc.vue?vue&type=template&id=6b42ce1c&scoped=true"
import script from "./Singleocc.vue?vue&type=script&lang=js"
export * from "./Singleocc.vue?vue&type=script&lang=js"

import "./Singleocc.vue?vue&type=style&index=0&id=6b42ce1c&scoped=true&lang=css"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-flechten_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b42ce1c"]])

export default __exports__